export default function AppTableHeader({ children, className, ...rest }) {
    return (
        <div className={`tableHeader ${className}`} {...rest}>
            {children}
        </div>
    );
};
